import camelCase from '../lib/camelCase';
import Immutable from 'immutable';
import qs from 'qs';

function transformOrderFromApi(payload) {
    const result = camelCase(payload);

    if (result.createdAt) result.createdAt = new Date(result.createdAt);
    if (result.serviceId) result.serviceId = parseInt(result.serviceId, 10);
    if (result.regionId) result.regionId = parseInt(result.regionId, 10);

    return result;
}

export function get(api, params = {}) {
    return api.get(api.url(`orders/${params.code}`), {
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformOrderFromApi(response.payload))
                : response;
        },
    });
}

export function getLabel(api, params = {}) {
    return api.get(api.url(`orders/${params.order}/label/status`), {
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(response.payload)
                : response;
        },
    });
}

export function validateStep(api, data) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            reject({error: {data: {error: 'validation.timeout_error', fields: {validation: ['timeout error']}}}});
        }, 10000)
        api.post(api.url('orders/step/validate'), data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest',
            },
            transformRequest(payload) {
                return qs.stringify(payload);
            },
        })
            .then((response) => {
                if (response.error) {
                    reject(response.error);
                } else {
                    resolve(response);
                }
            })
            .catch(reject);
    });
}

export function dispatch(api, data) {
    return api.post(api.url('orders/store'), data, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest',
        },
        transformRequest(payload) {
            return qs.stringify(payload);
        },
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformOrderFromApi(response.payload))
                : response;
        },
    });
}

export function tracking(api, code) {
    return api.get(api.url(`orders/tracking/${code}`), {
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformOrderFromApi(response.payload))
                : response;
        },
    });
}

export default {
    get,
    dispatch,
    getLabel,
    validateStep,
    tracking,
};
